import api from './client';
import { getOAuthCallbackOrigin } from './client';

// Revolut Business API (multi-account)
export const revolutAPI = {
  getStatus: () => api.get('/integrations/revolut/status'),
  // payments=true asks Revolut for READ,PAY (scheduled payments, approvers only)
  initiateAuth: (connectionId, { payments = false } = {}) => api.get(`/integrations/revolut/auth/${connectionId}`, {
    params: payments ? { origin: getOAuthCallbackOrigin(), payments: true } : { origin: getOAuthCallbackOrigin() },
  }),
  disconnect: (connectionId) => api.delete(`/integrations/revolut/disconnect/${connectionId}`),
  sync: (connectionId) => connectionId
    ? api.post(`/integrations/revolut/sync/${connectionId}`)
    : api.post('/integrations/revolut/sync'),
  getBalances: () => api.get('/integrations/revolut/balances'),
};
